import { Montserrat } from "next/font/google";

/**
 * Application fonts. Add new `next/font` instances here, then:
 * 1. Export them below with a unique `variable` (e.g. `--font-heading`).
 * 2. Add their `.variable` to `fontClassNames`.
 * 3. Map the variable in `app/globals.css` under `@theme inline`.
 */

/** Primary UI / body font */
export const fontSans = Montserrat({
  variable: "--font-sans",
  subsets: ["latin"],
  display: "swap",
});

/** Class names for <html> — keeps all font CSS variables in scope */
export const fontClassNames = [
  fontSans.variable,
].join(" ");
